module.exports = __webpack_public_path__ + "static/assets/21a05de4282370977032cd38d32f8099.png";